import React from "react";
import Accordions from "../../../components/Accordions";

const Sem1Auto1 = () => {
  const data = [
    {
      subjectName: "2023 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1vtwgQ94TzX3LmGBUvEazkgur5oB2U4zK/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/1sjQwRdZPbfVvj2acEwoCop8sbjmA6vA8/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1NSQr2hjREFpyaZko5enxw2RfwIwIb1hE/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">BME Sem - 1</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem1Auto1;
